/* @flow strict */

import * as React from 'react';
import moment from 'moment';
import { currency } from '/client/src/constants/';
import { format } from '/client/src/utils/amountTransformation';
import { EventDetailContainerContext } from '/client/src/contexts/EventDetailContainer';
import { convertToLocalTime } from '/client/src/utils/jstz';

export const columns = (
  showPaymentModal: boolean,
  handleShowPaymentModal: () => void,
  handleShowPaymentModalOrderId: null | string | number
): [] => {
  const eventContext = React.useContext(EventDetailContainerContext);
  const time_zone_id = _.get(eventContext, 'eventDetail.time_zone_id', '');

  return [
    {
        selector: 'customer_first_name',
        name: 'First Name',
        sortable: true,
        cell: (row: {}): React.Element => {
          return (
            <>
              <i
                className='glyphicon glyphicon-cog'
                style={{
                  marginRight: '.5rem',
                  cursor: 'pointer'
                }}
                onClick={(): any => {
                  handleShowPaymentModal(!showPaymentModal);
                  handleShowPaymentModalOrderId(row.id);
                }}
              />
              {row.customer_first_name}
            </>
          );
        }
    },
    {
        selector: 'customer_last_name',
        name: 'Last Name',
        sortable: true
    },
    {
        selector: 'creation_time',
        name: 'Date Purchased',
        sortable: true,
        cell: (row: {}): React.Element => {
         return convertToLocalTime(_.get(row, 'creation_time', ''), time_zone_id, 'MM/DD/YY h:mm a z');
        }
    },
    {
        selector: 'customer_email_address',
        name: 'Email',
        sortable: true
    },
    {
        selector: 'customer_phone_number',
        name: 'Phone',
        sortable: true
    },
    {
        selector: 'totalPay',
        name: 'Total Paid',
        sortable: true,
        cell: (row: any): any => {
          // return `${currency[row.currency]}${row.totalPay || 0}`;
          return format(currency[row.currency], row.amount);
        }
    },
    {
        selector: 'payout',
        name: 'Payout',
        sortable: true,
        cell: (row: any): any => {
          return format(currency[row.currency], row.merchant_revenue - row.merchant_revenue_refund);
          // return `$${row.payout || 0}`;
        }
    },
    {
        selector: 'donation_amount',
        name: 'Total Donation',
        sortable: true,
        cell: (row: any): any => {
          // return `$${row.donation_amount || 0}`;
          return format(currency[row.currency], row.merchant_donation_revenue - row.merchant_donation_revenue_refund);
        }
    },
    {
        selector: 'refunded',
        name: 'Refunded',
        sortable: true,
        cell: (row: any): any => {
          return format(currency[row.currency], row.amount_refund);
        }
    }
  ];
};

// export const data = [
//   {
//     fname: 'tickets test',
//     lname: 'tickets test',
//     datePurch: 'tickets test',
//     email: 'tickets test',
//     phone: 'tickets test',
//     totalPay: 'tickets test',
//     payout: 'ticketType',
//     totalDon: 'totalDon'
//   },
//   {
//     fname: '2 tickets test',
//     lname: '2 tickets test',
//     datePurch: '2 tickets test',
//     email: '2 tickets test',
//     phone: '2 tickets test',
//     totalPay: '2 tickets test',
//     payout: '2 ticketType',
//     totalDon: 'totalDon'
//   }
// ];
